import React from 'react';
import { codeErrorResponse } from 'functions/codeError';
import ModalPortal from 'components/Modal';
import './style.sass';

export function ModalErrorSolicitarCredito(props) {
    const {
        errorCode,
        section,
        handleClose,
        message
    } = props

    // console.log('errorCode: ',errorCode)
    // console.log('section: ',section)

    return (
        <ModalPortal type="btn" onClose={handleClose} >
            <div className="bxModalE">
                <img src="img/alert.png"></img>
                <p className="copyPrincipal">¡Ha ocurrido un error!</p>
                <p className="copyNormal1">error {errorCode.codMen}</p>
                <br />
                <p className="copyNormal1">{!message
                    ? codeErrorResponse(errorCode.codMen, section)
                    : message
                }</p>

                <p className="copyNormal">Por favor, intenta nuevamente.</p>
            </div>
        </ModalPortal>
    )
}